// extracted by mini-css-extract-plugin
module.exports = {"card":"RoommatesPanel_card__1WVNo","header":"RoommatesPanel_header__1aCt_","title":"RoommatesPanel_title__9Xtb3"};